import { BufferSourceConverter } from "pvtsutils";
import { ByteStream } from "./byte_stream";
export class Structure {
    static createStream(bytes) {
        const view = BufferSourceConverter.toUint8Array(bytes);
        return new ByteStream(view);
    }
}
